// ─────────────────────────────────────────────────────────────────
// Glass-i — Organization chart helpers (Stage HRMS-3). Pure functions.
// ─────────────────────────────────────────────────────────────────

// Count every node in a manager forest (roots + all descendants).
export function countForest(forest) {
  if (!Array.isArray(forest)) return 0;
  let n = 0;
  for (const node of forest) {
    n += 1;
    if (node && Array.isArray(node.children)) n += countForest(node.children);
  }
  return n;
}

// Convert a manager forest into AntD Tree data (title supplied by caller
// via renderTitle, keyed by employee id).
export function forestToTreeData(forest, renderTitle) {
  if (!Array.isArray(forest)) return [];
  return forest.map((node) => ({
    key: node.id,
    title: typeof renderTitle === 'function' ? renderTitle(node) : node.employeeName,
    node,
    children: forestToTreeData(node.children || [], renderTitle)
  }));
}

// All node keys in a forest — used to expand-all.
export function allKeys(forest) {
  const keys = [];
  const walk = (list) => {
    for (const node of (list || [])) {
      keys.push(node.id);
      walk(node.children || []);
    }
  };
  walk(forest);
  return keys;
}

// Safe summary accessor with defaults.
export function summaryCards(summary = {}) {
  const s = summary || {};
  return [
    { key: 'branches', label: 'Branches', value: s.branches || 0 },
    { key: 'departments', label: 'Departments', value: s.departments || 0 },
    { key: 'designations', label: 'Designations', value: s.designations || 0 },
    { key: 'employees', label: 'Employees', value: s.employees || 0 },
    { key: 'activeEmployees', label: 'Active', value: s.activeEmployees || 0 },
    { key: 'salespersons', label: 'Salespersons', value: s.salespersons || 0 }
  ];
}
